window.addEventListener('load', function () {
  async function updateCartFeatures() {
    let specialItemsCount = await window.trynow.cart.getTryNowItemCount();
    let upCartBadge = document.querySelector('.upcart-trust-badge');
    let cartItems = document.querySelectorAll('.upcart-product-item');
    let checkoutButton = document.querySelector('.upcart-checkout-button');

    // Calculate total for non-Try Now items
    let nonTryNowTotal = 0;

    cartItems.forEach(item => {
      let itemProperty = item.querySelector('.upcart-item-property-subscription');
      let priceSpan = item.querySelector('.upcart-item-price');
      if (
        itemProperty &&
        itemProperty.textContent &&
        itemProperty.textContent.toLowerCase().includes('try before you buy')
      ) {
        if (priceSpan) {
          // Only add original price if not already present
          if (!item.querySelector('.upcart-item-original-price')) {
            // Get the original price before $0.00 was applied
            let originalPrice = priceSpan.textContent;
            if (originalPrice === "$0.00" && priceSpan.dataset.originalPrice) {
              originalPrice = priceSpan.dataset.originalPrice;
            }
            priceSpan.dataset.originalPrice = originalPrice;

            // Create the crossed-out price element, smaller font
            let crossed = document.createElement('span');
            crossed.className = 'upcart-item-original-price';
            crossed.style.textDecoration = 'line-through';
            crossed.style.marginRight = '6px';
            crossed.style.color = '#888';
            crossed.style.fontSize = '0.9em'; // Make it a little smaller
            crossed.textContent = originalPrice;
            priceSpan.parentNode.insertBefore(crossed, priceSpan);
          }
          // Always set visible price to $0.00
          priceSpan.textContent = '$0.00';
        }
      } else if (priceSpan) {
        // Only add if priceSpan exists and has a value
        let priceText = priceSpan.textContent.replace(/[^0-9.]/g, '');
        let price = parseFloat(priceText);
        if (!isNaN(price)) nonTryNowTotal += price;
        // If this is not a TryNow item, remove any previous original price markup
        let crossed = item.querySelector('.upcart-item-original-price');
        if (crossed) crossed.remove();
        // If we previously overwrote the price, restore it from the data attribute
        if (priceSpan.dataset.originalPrice) {
          priceSpan.textContent = priceSpan.dataset.originalPrice;
          delete priceSpan.dataset.originalPrice;
        }
      }
    });

    // Format as currency
    let formattedTotal = `$${nonTryNowTotal.toFixed(2)}`;

    if (specialItemsCount > 0) {
      if (upCartBadge) upCartBadge.style.display = 'none';
      if (checkoutButton) checkoutButton.textContent = `Checkout • ${formattedTotal}`;
    } else {
      if (upCartBadge) upCartBadge.style.display = 'block';
      if (checkoutButton) checkoutButton.textContent = `Checkout • ${formattedTotal}`;
    }
  }

  window.upcartOnCartUpdated = () => {
    setTimeout(updateCartFeatures, 500);
  };

  window.upcartOnAddToCart = () => {
    let upCart = document.querySelector('#UpcartPopup');
    if (!upCart.classList.contains('upcartPopupShow')) {
      if (typeof upcartRefreshCart === 'function') upcartRefreshCart();
      if (typeof upcartOpenCart === 'function') upcartOpenCart();
    }
  };

  updateCartFeatures();
});